import React, { useEffect, useState } from 'react'

import language from '../../data/language.json'

import Cards from '../Cards/Cards'
import Select from 'react-select'

import './charWindow.scss'
import JobSelect from './subComponents/JobSelect'
import StatSelect from './subComponents/StatSelect'
import BaseLevelSelect from './subComponents/BaseLevelSelect'
import JobLevelSelect from './subComponents/JobLevelSelect'
// import SubStats from '../SubStats/SubStats'

import * as JobName from '../../data/jobID'

//context
import { useContext } from 'react'
//character context
import { CharacterContext } from '../../contexts/character'
//subStat context
import { SubStatsContext } from '../../contexts/subStats'
//dn context
import { DBContext } from '../../contexts/databases'
//User Interface Context
import { UIContext } from '../../contexts/ui'
function CharWindow(props) {
	const {
		// STR,
		// AGI,
		// VIT,
		// INT,
		// DEX,
		// LUK,
		bonusSTR,
		bonusAGI,
		bonusVIT,
		bonusINT,
		bonusDEX,
		bonusLUK,
		statPoints,
		extraATK,
		bonuses,
		job,
		changeJob,
		changeBaseLevel,
		// baseLevel,
		changeJobLevel,
		// jobLevel,
		// player,
		refreshPlayer,
		setTempInventory,
	} = useContext(CharacterContext)

	const {
		maxHP,
		maxSP,
		Def,
		softDef,
		softMdef,
		Mdef,
		hit,
		flee,
		perfectDodge,
		crit,
		aspd,
		statusATK,

		// weaponATK,
		baseWeaponDamage,
		statusMATK,
		baseWeaponMagicDamage,
		refinementBonus,
	} = useContext(SubStatsContext)
	const { setIsDbRefreshed } = useContext(DBContext)

	const { customStyles } = useContext(UIContext)
	const [savedStats, setsavedStats] = useState({
		str: 1,
		agi: 1,
		vit: 1,
		int: 1,
		dex: 1,
		luk: 1,
	})

	const statList = ['Str', 'Agi', 'Vit', 'Int', 'Dex', 'Luk']
	const bonusStatList = [
		bonusSTR,
		bonusAGI,
		bonusVIT,
		bonusINT,
		bonusDEX,
		bonusLUK,
	]
	const maxSaveSlots = 10

	for (let i = 0; i < maxSaveSlots; i++) {
		let stored = window.localStorage.getItem('saveSlot' + i)
		if (!stored) {
			window.localStorage.setItem(
				'saveSlot' + i,
				JSON.stringify({
					Stats: {
						str: 1,
						agi: 1,
						vit: 1,
						int: 1,
						dex: 1,
						luk: 1,
					},
					Job: 'Empty',
					BaseLevel: 1,
					JobLevel: 1,
				}),
			)
		}
	}
	useEffect(() => {
		SetSaveOptions(maxSaveSlots, setOptions)
	}, [])

	const [options, setOptions] = useState([
		CreateOption('Save Slot 1 : ' + GetJob(0), 'saveSlot' + 0, 0),
	])
	const [selectedValue, setSelectedValue] = useState([
		CreateOption('Save Slot 1 : ' + GetJob(0), 'saveSlot' + 0, 0),
	])

	return (
		<div className='charWindow'>
			<Cards Name={'Stats'}>
				<Select
					menuPosition='fixed'
					styles={customStyles}
					value={selectedValue}
					id={props.id}
					className='StatSelect'
					onChange={(event) => {
						setSelectedValue([
							CreateOption(
								'Save Slot ' +
									(Number(event.value) + 1) +
									' : ' +
									GetJob(Number(event.value)),
								'saveSlot' + Number(event.value),
								Number(event.value),
							),
						])
					}}
					options={options}
				/>
				<button
					onClick={() => {
						// refreshPlayer()

						let newPlayer = refreshPlayer()
						// console.log(newPlayer)
						try {
							window.localStorage.setItem(
								selectedValue[0].key,
								JSON.stringify(
									newPlayer,
									// 	{
									// 	Stats: {
									// 		str: STR - bonusSTR,
									// 		agi: AGI - bonusAGI,
									// 		vit: VIT - bonusVIT,
									// 		int: INT - bonusINT,
									// 		dex: DEX - bonusDEX,
									// 		luk: LUK - bonusLUK,
									// 	},
									// 	Job: job,
									// 	BaseLevel: baseLevel,
									// 	JobLevel: jobLevel,
									// }
								),
							)
						} catch (error) {
							console.error('failed to load localStorage', error)
						}
						SetSaveOptions(maxSaveSlots, setOptions)
						setSelectedValue([
							CreateOption(
								'Save Slot ' +
									(Number(selectedValue[0].value) + 1) +
									' : ' +
									GetJob(Number(selectedValue[0].value)),
								'saveSlot' + Number(selectedValue[0].value),
								Number(selectedValue[0].value),
							),
						])
					}}
				>
					Save
				</button>
				<button
					onClick={() => {
						const stored = window.localStorage.getItem(
							selectedValue[0].key,
						)
						if (!stored) {
							console.warn('No value for', selectedValue[0].key)
							return
						}

						const stats = JSON.parse(stored)?.Stats
						const savedJob = JSON.parse(stored)?.Job
						const savedBaseLevel = JSON.parse(stored)?.BaseLevel
						const savedJobLevel = JSON.parse(stored)?.JobLevel
						const savedInventory = JSON.parse(stored)?.Inventory
						if (!stats) {
							console.warn('Format Stats not found')
							return
						}
						setsavedStats(
							Object.fromEntries(
								statList.map((stat) => [
									stat.toLowerCase(),
									stats[stat.toLowerCase()] ?? 1, // default value if undefined
								]),
							),
						)
						if (savedJob !== job) {
							console.log('different job')
							setIsDbRefreshed(false)
						}
						if (savedJob !== 'Empty') changeJob(savedJob)
						else changeJob(0)
						if (savedBaseLevel) changeBaseLevel(savedBaseLevel)
						else changeBaseLevel(1)

						if (savedJobLevel) changeJobLevel(savedJobLevel)
						else changeJobLevel(1)

						if (savedInventory) setTempInventory(savedInventory)
					}}
				>
					Load
				</button>
				<div className='chatStats'>
					<span className='LabelJob'>
						{language[props.currentLanguage]['job']}
					</span>
					<div className='SelectJob'>
						<JobSelect
							language='en'
							id='job'
							className=''
							customStyles={customStyles}
						/>
					</div>
					<span className='LabelBaseLv'>
						{language[props.currentLanguage]['baseLevel']}
					</span>
					<div className='SelectBaseLv'>
						<BaseLevelSelect
							id={'baseLevel'}
							className=''
							customStyles={customStyles}
						/>
					</div>
					<span className='LabelJobLv'>
						{language[props.currentLanguage]['jobLevel']}
					</span>
					<div className='SelectJobLv'>
						<JobLevelSelect
							id={'jobLevel'}
							className=''
							customStyles={customStyles}
						/>
					</div>
					{/* Stats labels */}
					{statList.map((st) => (
						<span className={'Label' + st} key={'Label' + st}>
							{
								language[props.currentLanguage][
									st.toLocaleLowerCase()
								]
							}
						</span>
					))}
					{/* Stats selects */}
					{statList.map((st) => (
						<div className={'Select' + st} key={'Select' + st}>
							<StatSelect
								id={st.toLocaleLowerCase()}
								customStyles={customStyles}
								test={savedStats}
							/>
						</div>
					))}
					{/* Stats bonus */}
					{bonusStatList.map((bst, index) => (
						<div
							className={'Bonus' + statList[index]}
							key={'Bonus' + statList[index]}
						>
							{bst >= 0 ? '+' + bst : '-' + bst}
						</div>
					))}
					<div className='LabelStatPointsLeft'>
						<span className='st_col-1 st_row-8'>
							{language[props.currentLanguage]['pointsLeft']}
						</span>
					</div>
					<div className='StatPointsLeft'>
						<div id={'pointsLeft'} className='st_col-2 st_row-8'>
							{statPoints}
						</div>
					</div>
					<div className='LabelMaxHP'>
						{language[props.currentLanguage].maxHP}
					</div>
					<div className='MaxHP'>{maxHP}</div>
					<div className='LabelMaxSP'>
						{language[props.currentLanguage].maxSP}
					</div>
					<div className='MaxSP'>{maxSP}</div>
					<div className='LabelATK'>
						{language[props.currentLanguage].atk}
					</div>
					<div className='ATK'>
						{statusATK} +
						{baseWeaponDamage + refinementBonus + extraATK}
					</div>
					<div className='LabelDEF'>
						{language[props.currentLanguage].def}
					</div>
					<div className='DEF'>
						{softDef} + {Def}
					</div>
					<div className='LabelMATK'>
						{language[props.currentLanguage].matk}
					</div>
					<div className='MATK'>
						{statusMATK} +
						{baseWeaponMagicDamage +
							refinementBonus +
							(bonuses.bMatk ? bonuses.bMatk : 0)}
					</div>
					<div className='LabelMDEF'>
						{language[props.currentLanguage].mdef}
					</div>
					<div className='MDEF'>
						{softMdef} + {Mdef}
					</div>
					<div className='LabelHit'>
						{language[props.currentLanguage].hit}
					</div>
					<div className='Hit'>{hit}</div>
					<div className='LabelFlee'>
						{language[props.currentLanguage].flee}
					</div>
					<div className='Flee'>
						{flee} + {perfectDodge}
					</div>
					<div className='LabelCritRate'>
						{language[props.currentLanguage].critRate}
					</div>
					<div className='CritRate'>{crit}</div>
					<div className='LabelASPD'>
						{language[props.currentLanguage].aspd}
					</div>
					<div className='ASPD'>{aspd}</div>
				</div>
			</Cards>
		</div>
	)
}

function CreateOption(label_, key_, value_) {
	return {
		value: Number(value_),
		label: label_,
		key: key_,
	}
}

function GetJob(slot) {
	return JSON.parse(window.localStorage.getItem('saveSlot' + slot))?.Job ===
		'Empty'
		? 'None'
		: JobName.getClassName(
				JSON.parse(window.localStorage.getItem('saveSlot' + slot)).Job,
			)
}

function SetSaveOptions(maxSaveSlots, setOptions) {
	const newOptions = []
	for (let i = 0; i < maxSaveSlots; i++) {
		// let stored = window.localStorage.getItem('saveSlot' + i)
		// console.log(JSON.parse(stored)?.Job)
		newOptions.push(
			CreateOption(
				'Save Slot ' + (i + 1) + ' : ' + GetJob(i),
				'saveSlot' + i,
				i,
			),
		)
	}
	setOptions(newOptions)
}
export default CharWindow
